import {Typography} from "@mui/material";
import HeartBrokenIcon from "@mui/icons-material/HeartBroken";

export default function PageNotFound(){
    return<>
        <Typography variant={'h3'} sx={{m:'auto',textAlign:'center',pt:6,pb:1}}>404 | Page Not Found</Typography>
        <HeartBrokenIcon sx={{m:'auto',display:'block',fontSize:60}}/>
    </>
}